module.exports = __webpack_public_path__ + "img/signup-guide-05-01.29d80104.png";